import Header from "./Header"
import Contant from "./contant"
import Footer from "./Footer"

export default function Batch(){
   
    return(
        <>
        <Header />
        <Contant />
        <Footer/>
        </>
    )
}